export default function Filtros({
  filtroApp,
  setFiltroApp,
  appsDisponibles,
  filtroEstatus,
  setFiltroEstatus,
  estatusDisponibles,
}) {
  return (
    <div className="flex gap-4 mb-4 justify-end mt-1">
      <select
        value={filtroApp}
        onChange={(e) => setFiltroApp(e.target.value)}
        className="border border-gray-300 rounded-full px-4 py-2 text-sm cursor-pointer
                  bg-white hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500
                  transition duration-200"
      >
        <option value="">Todas las apps</option>
        {appsDisponibles.map((app) => (
          <option key={app} value={app}>
            {app}
          </option>
        ))}
      </select>

      <select
        value={filtroEstatus}
        onChange={(e) => setFiltroEstatus(e.target.value)}
        className="border border-gray-300 rounded-full px-4 py-2 text-sm cursor-pointer
                  bg-white hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500
                  transition duration-200"
      >
        <option value="">Todos los estatus</option>
        {estatusDisponibles.map((est) => (
          <option key={est} value={est}>
            {est}
          </option>
        ))}
      </select>
    </div>
  );
}
